import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementQueueRules(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementQueueRules?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementQueueRules", responseData.data);
  },
  async fetchExportEngagementQueueRules() {
    await utils.utility.fetch(
      `api/Setting/GetExportEngagementQueueRule`,
      "GET",
      null,
      null
    );
  },
  async fetchEngagementQueueRuleDetail(context, payload) {
    const response = await utils.utility.fetch(
      `api/Setting/GetEngagementQueueRuleDetail?id=${payload.id}`,
      "GET",
      null,
      null
    );

    context.commit("setEngagementQueueRuleDetail", response.data);
  },

  async fetchFeedQueueAssignment(context, payload) {
    const response = await utils.utility.fetch(
      `api/Setting/GetFeedQueueAssignment?feedId=${payload.feedId}`,
      "GET",
      null,
      null
    );

    context.commit("setFeedQueueAssignment", response.data);
  },

  clearFeedQueueAssignment(context) {
    context.commit("setFeedQueueAssignment", null);
  },

  async fetchWorksaceGroupIsStorm(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetWorksaceGroupIsStorm`,
      "GET",
      null,
      null
    );
    context.commit("setWorksaceGroupIsStorm", response.data);
  },

  
  async fetchEngagementQueueRuleTags(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetEngagementQueueRuleTags`,
      "GET",
      null,
      null
    );

    context.commit("setEngagementQueueRuleTags", response.data);
  },

  async postEngagementQueueRule(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementQueueRule`,
      "POST",
      null,
      payload
    );
  },
  async putEngagementQueueRule(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateEngagementQueueRule`,
      "PUT",
      null,
      payload
    );
  },

  async deleteEngagementQueueRule(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementQueueRule`,
      "POST",
      null,
      postData
    );
  },
};
